export default "__VITE_ASSET__JjFw9EV4__"